import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LandingPageService {
  private landingPageSubject = new BehaviorSubject<boolean>(true);
  landingPage$ = this.landingPageSubject.asObservable();

  setLandingPage(value: boolean): void {
    this.landingPageSubject.next(value);
  }

  getLandingPage(): boolean {
    return this.landingPageSubject.value;
  }
}
